import invoices from './invoices.js';
import sales from './sales.js';
import estimates from './estimates.js';
import salesOrders from './sales-orders.js';
import proformaInvoices from './proforma-invoices.js';
import creditMemos from './sales-credit-memos.js';
import recurringInvoices from './recurring-invoices.js';

export default [...invoices, ...sales, ...estimates, ...salesOrders, ...proformaInvoices, ...creditMemos, ...recurringInvoices];
